import { inject, Injectable } from '@angular/core';
import { LoggerService } from '../../services/logger/logger-service/logger.service';
import { AuthService } from '../auth-service.interface';
import { UserService } from '../user-service/user.service';
import { Subject, take, takeUntil, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../token-service/token.service';

/**
 * Provides mock methods for logging user in and out.
 */
@Injectable({
    providedIn: 'root',
})
export class AuthServiceMock implements AuthService {
    destroySubject$ = new Subject<void>();

    // Injectables
    private logger = inject(LoggerService);
    private activatedRoute = inject(ActivatedRoute);
    private userService = inject(UserService);
    private router = inject(Router);
    private tokenService = inject(TokenService);

    constructor() {
        this.setupParams();
    }

    login() {
        this.logger.debug('mock auth login triggered');
    }

    logout() {}

    isLoggedIn(): boolean {
        return true;
    }

    setupParams() {
        this.activatedRoute.queryParams.pipe(takeUntil(this.destroySubject$)).subscribe(params => {
            const jwt = params['jwt'];
            if (jwt) {
                this.setToken(jwt);
                this.userService
                    .getUser()
                    .pipe(
                        take(1),
                        tap(() => {
                            this.router.navigate(['']);
                        }),
                    )
                    .subscribe();
            }
        });
    }

    setToken(token: string): void {
        this.tokenService.setToken(token);
    }
}
